<template>
    <div v-if="produto" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Produto</h4>
        <router-link to="/cadastros/produtos">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="Informações Gerais">
          <p><strong>Código:</strong> {{ produto.codigo }}</p>
          <p><strong>Nome:</strong> {{ produto.nome }}</p>
          <p><strong>Categoria:</strong> {{ categoriaNome || '—' }}</p>
          <p><strong>Unidade:</strong> {{ produto.unidade || '—' }}</p>
          <p><strong>Status:</strong> {{ verificarAtivo(produto.ativo) }}</p>
        </FormSection>
  
        <FormSection title="Estoque">
          <p><strong>Disponível:</strong> {{ produto.estoque }}</p>
          <p><strong>Mínimo:</strong> {{ produto.estoque_minimo }}</p>
        </FormSection>
  
        <FormSection title="Preços">
          <p>
            <strong>Preço de Custo:</strong>
            {{ produto.preco_custo != null ? formatarValor(produto.preco_custo) : '—' }}
          </p>
          <p>
            <strong>Preço de Venda:</strong>
            {{ produto.preco_venda != null ? formatarValor(produto.preco_venda) : '—' }}
          </p>
        </FormSection>
  
        <!-- <FormSection title="Timestamps">
          <p>
            <strong>Criado em:</strong>
            {{ produto.criado_em ? formatarData(produto.criado_em) : '—' }}
          </p>
          <p>
            <strong>Atualizado em:</strong>
            {{ produto.atualizado_em ? formatarData(produto.atualizado_em) : '—' }}
          </p>
        </FormSection> -->
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from '@/services/axios';
  import FormSection from '@/components/Layout/FormSection.vue';
//   import LoadingSpinner from '@/components/Layout/LoadingSpinner.vue';
  import globalUtils from '@/utils/globalUtils.js';
  
  export default {
    components: {
      FormSection,
    },
    data() {
      return {
        produto: null,
        categoriaNome: null
      };
    },
    methods: {
      async carregarDetalhesProduto() {
        try {
          // 1) busca o produto
          const { data } = await axios.get(
            `/cadastros/produtos/${this.$route.params.id}`
          );
          this.produto = data;
  
          // 2) busca o nome da categoria
          const catRes = await axios.get(
            `/cadastros/categorias-de-produtos/${data.categoria_id}`
          );
          this.categoriaNome = catRes.data.nome;
        } catch (error) {
          console.error('Erro ao carregar detalhes do produto:', error);
        }
      },
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return 'Não informado';
        }
        return valor ? 'Ativo' : 'Inativo';
      },
      formatarValor(valor) {
        return globalUtils.formatarValor(valor);
      },
      formatarData(data) {
        return globalUtils.formatarData
          ? globalUtils.formatarData(data)
          : new Date(data).toLocaleString('pt-BR');
      }
    },
    mounted() {
      this.carregarDetalhesProduto();
    }
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
  }
  .form-content {
    margin-top: 1.5rem;
  }
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  